import ddt from '@wix/da-ddt';
import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { pushPopoverWithOptions, removePopover } from './actionCreators';
import { PopoverArrayItem } from './types';

export default {
  [reduxKey as string]: handleActions<PopoverArrayItem[], any>(
    {
      [pushPopoverWithOptions.toString()]: (
        state,
        action: ReturnType<typeof pushPopoverWithOptions>
      ) => {
        const existingPopover = state.find(
          item => item.id === action.payload.id
        );
        if (existingPopover) {
          ddt.warn(
            'popovers',
            'Pushed a popover with an id that already exists in the array'
          );
        }
        return [...state, action.payload];
      },
      [removePopover.toString()]: (
        state,
        action: ReturnType<typeof removePopover>
      ) => {
        return state.filter(item => item.id !== action.payload);
      },
    },
    []
  ),
};
